var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErrorRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1507_137",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1507_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.19824 15C2.19824 16.6812 2.52936 18.3459 3.17271 19.899C3.81607 21.4523 4.75904 22.8634 5.94778 24.0522C7.13653 25.2409 8.54779 26.1839 10.101 26.8273C11.6541 27.4706 13.3188 27.8018 15 27.8018C16.6811 27.8018 18.3458 27.4706 19.8989 26.8273C21.4522 26.1839 22.8633 25.2409 24.0521 24.0522C25.2409 22.8634 26.1839 21.4523 26.8272 19.899C27.4706 18.3459 27.8017 16.6812 27.8017 15C27.8017 13.3189 27.4706 11.6542 26.8272 10.101C26.1839 8.54785 25.2409 7.13659 24.0521 5.94784C22.8633 4.7591 21.4522 3.81613 19.8989 3.17277C18.3458 2.52943 16.6811 2.1983 15 2.1983C13.3188 2.1983 11.6541 2.52943 10.101 3.17277C8.54779 3.81613 7.13653 4.7591 5.94778 5.94784C4.75904 7.13659 3.81607 8.54785 3.17271 10.101C2.52936 11.6542 2.19824 13.3189 2.19824 15Z",
    fill: "#B91C1C",
    stroke: "#B91C1C",
    strokeWidth: 2.13362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.87933V16.7069",
    stroke: "white",
    strokeWidth: 2.13362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20.6896V20.704",
    stroke: "white",
    strokeWidth: 2.56034,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorRed);
export default __webpack_public_path__ + "static/media/Icon_Error_Red.bbb8f5b1f1a7b34e7d388d0f9ffe6c54.svg";
export { ForwardRef as ReactComponent };